import { Skeleton } from '../../../Skeleton'

import * as styles from './AITextGenerationDraftPanelSkeleton.module.css'

function AITextGenerationDraftPanelSkeleton() {
  return (
    <div className={styles.AITextGenerationDraftPanelSkeleton}>
      <div className={styles.skeletonHeader}>
        <Skeleton className={styles.skeletonAvatar} />
        <Skeleton className={styles.skeletonPrompt} />
        <Skeleton className={styles.skeletonClose} />
      </div>

      <div className={styles.skeletonContent}>
        <Skeleton className={styles.skeletonLineFull} />
        <Skeleton className={styles.skeletonLineMedium} />
        <Skeleton className={styles.skeletonLineShort} />
      </div>
    </div>
  )
}

export default AITextGenerationDraftPanelSkeleton
